import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getPropertyDetail } from '../../../Redux/Slices/BON-Frontend/propertySlice';

export const BookingFormHeader = () => {
     const dispatch = useDispatch();

  const { propertyDetails } = useSelector(
    (state) => state.property
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pid = params.get("pid");

    if (pid) {
      dispatch(getPropertyDetail(pid));
    }
  }, [dispatch]);
    return (
        <>
            <nav className="bp-navbar navbar-expand-md fixed-top">
                <div className="container-fluid" style={{ padding: "13px 6rem 1rem" }}>
                    <img src={propertyDetails?.PropertyLogo} alt='logo' className='me-3' style={{ width: "6rem" }} />
                    <a className="bp-navbar-brand fw-bold font-serif fs-4 text-dark" href="/">
                        {propertyDetails?.DisplayName}
                    </a>
                    <button
                        className="navbar-toggler"
                        data-bs-target="#navbarNav"
                        data-bs-toggle="collapse"
                        type="button"
                    >
                        <span className="navbar-toggler-icon" />
                    </button>

                </div>
            </nav>
        </>
    )
}
